// extracted by mini-css-extract-plugin
module.exports = {"otpButton":"AuthForm_otpButton__ILxUr"};